export const QUANTITY_LIMIT_TYPES = {
  amt_rub: "по сумме",
  amt_acc_curr: "по сумме",
  quantity: "по количеству транзакций",
  amt_usd: "по сумме",
  amt_eur: "по сумме",
};

export const CURRENCY_LIMIT_TYPES = {
  amt_rub: "RUB",
  amt_acc_curr: "в валюте счёта",
  quantity: "операций",
  amt_usd: "USD",
  amt_eur: "EUR",
};

export const LIMIT_PERIOD_TYPES = {
  per_operation: "на операцию",
  daily: "дневной",
  monthly: "месячный",
  for_n_days: "на несколько дней",
};

export const SHOW_DATES = {
  monthly: true,
  for_n_days: true,
};



// WEBPACK FOOTER //
// ./src/components/emission/cards/limits/CardLimitBadge/CONSTANTS.js